// Game Configuration Constants
// Extracted from Game.jsx for better organization

// Game timing constants
export const GAME_CONFIG = {
  // Timing
  PRIZE_AMOUNT: 0.0001,
  GAME_START_DELAY: 10,
  MATCH_START_DELAY: 20,
  DO_PRIZES: false,
  
  // Player counts
  DEFAULT_HOLDERS_TO_FETCH: 350,
  RANDOM_HOLDERS_TO_FETCH: 100,
  
  // Combat
  BASE_MELEE_RANGE: 52, // unscaled melee distance baseline
  
  // Chat
  MAX_CHAT_LINES: 50,
  
  // Audio
  BATTLE_MUSIC_KEYS: [
    'music/battle/PixelatedShowdown1.mp3'
  ]
};

// Debug configuration
export const DEBUG_CONFIG = {
  CHAT: (() => {
    try {
      const qs = new URLSearchParams(window.location.search);
      return (process.env.REACT_APP_DEBUG_CHAT === 'true') || 
             (qs.get('debugChat') === '1') || 
             (localStorage.getItem('debugChat') === '1');
    } catch (_) {
      return false;
    }
  })()
};

// URL parameter parsing
export const URL_CONFIG = (() => {
  const urlParams = new URLSearchParams(window.location.search);
  const holdersParam = urlParams.get('holders');
  
  let holdersToFetch = GAME_CONFIG.DEFAULT_HOLDERS_TO_FETCH;
  if (holdersParam && !isNaN(parseInt(holdersParam))) {
    const parsed = parseInt(holdersParam);
    holdersToFetch = Math.min(1000, parsed);
  }
  
  return {
    holdersToFetch
  };
})();

// Session-persistent audio preferences
export const audioPrefs = {
  musicUserVol: null,   // last non-zero music volume user set
  musicMuted: null,     // whether user muted music
  sfxUserVol: null,     // last SFX base volume user set
  sfxMuted: null        // whether user muted SFX
};

// Persist auto-join across scene restarts: userId -> remaining matches to auto-join
export const autoJoinRemaining = new Map();

// Persist join queue across scene restarts: array of join requests
export const joinQueue = [];

// Persist last played battle music across scene restarts
export let lastBattleMusicKeyGlobal = null;

// Debug logging functions
export const chatDbg = (...args) => { 
  try { 
    if (DEBUG_CONFIG.CHAT) console.log(...args); 
  } catch (_) {} 
};

export const chatWarn = (...args) => { 
  try { 
    if (DEBUG_CONFIG.CHAT) console.warn(...args); 
  } catch (_) {} 
};

// Utility functions
export function truncateWallet(walletAddress) {
  if (!walletAddress || walletAddress.length < 7) {
    return walletAddress || 'Unknown';
  }
  const firstThree = walletAddress.substring(0, 3);
  const lastFour = walletAddress.substring(walletAddress.length - 4);
  return `${firstThree}...${lastFour}`;
}

export function nameFromWalletPrefix(walletAddress) {
  if (!walletAddress) return 'Unknown';
  try {
    const s = String(walletAddress);
    return s.substring(0, Math.min(6, s.length));
  } catch (_) {
    return 'Unknown';
  }
}

export function truncateUsername(name, max = 20) {
  try {
    if (!name || typeof name !== 'string') return name || '';
    return (name.length >= max) ? (name.slice(0, max) + '...') : name;
  } catch (_) { 
    return name; 
  }
}
